<div>
  <ul class="nav nav-tabs">
    <li class="nav-item" [style]="{'background-color':activeTab=='Logs'?'aliceblue':'white'}">
      <button class="navbar" (click)="setActiveTab('Logs')"><em class="fa fa-list-alt" style="color: #ff1fff;"></em>{{"
        Logs" | translate}}</button>
    </li>
    <!-- PT Parameters temporarily disabled for iOS -->
    @if (device.platform!='iOS') {
    <li class="nav-item" [style]="{'background-color':activeTab=='PT'?'aliceblue':'white'}">
      <button class="navbar" (click)="setActiveTab('PT');"><em class="fa fa-dashboard fa-fw"
          style="color: #f84a15;"></em>{{" PT Parameters" | translate}}</button>
    </li>
    }
  </ul>
  <div class="tab-content">
    <!-- logs -->
    @if (this.activeTab=='Logs') {
    <div id="logs" class="">
      <div class="protean-logs">
        <div class="widget-container fluid-height">
          <div class="widget-content">
            <table class="table table-condensed logcat-filters-table" ng-show="true">
              <tr style="padding: 0; margin: 0;display: block;">
                <td width="1%" padding="0">
                  <!-- ios change  -->
                  <button id="log" (click)="Logscontrol()" title="{{ 'Start/Stop Logging' | translate }}"
                    class="custom-btn" [disabled]="device.platform=='iOS'">
                    <i class="fa fa-list-alt" style="margin-top: 1px;margin-right: 1px;"></i>
                    {{ started ? 'Stop' : 'Get' }}
                  </button>
                  <!-- ios change  -->
                </td>
                <td>
                  <select id="selectid" [(ngModel)]="filters.priority" name="priority" (change)="loglevels(filters.priority)"
                    style="border-radius: 0.8vh;">
                    <option value="" selected>{{"Logcat Level" | uppercase}}</option>
                    @for (l of filters.levelNumbers; track l) {
                    <option [ngValue]="l">{{l.name}}</option>
                    }
                  </select>
                </td>
                <td width="50%">
                  <input class="input-sm form-control" [(ngModel)]="filters.message" name="message" type="text"
                    placeholder="{{'Text'|translate}}" />
                </td>
                <td width="15%">
                  <input class="input-sm form-control" [(ngModel)]="filters.date" name="date" type="text"
                    (keypress)="validateDate($event)" (input)="sanitizeInputDate($event)"
                    placeholder="{{'Time'|translate}}" />
                </td>
                <td width="14%" ng-if="$root.platform == &quot;native&quot;">
                  <input class="input-sm form-control" [(ngModel)]="filters.tag" name="tag" type="text"
                    placeholder="{{&quot;Tag&quot;|translate}}" />
                </td>
                <td width="0">
                  <button class="btn btn-xs btn-danger-outline" (click)="clearTable()" ng-disabled="false"
                    title="{{'Clear'|translate}}">
                    <i class="fa fa-trash-o" style="color: red;"></i>
                    <span class="red"> {{"Clear" | translate}}</span>
                  </button>
                </td>
                <td width="0">
                  <button class="btn btn-xs" (click)="saveLogs()" ng-disabled="false" [title]="'Save Logs'| translate">
                    <i class="fa fa-save" style="color: green;"></i>
                    <span style="color: green;">{{"Save Logs" | translate}}</span>
                  </button>
                </td>
              </tr>
            </table>
            <app-logcat-table [filters]="filters" add-row="lastEntry"></app-logcat-table>
          </div>
        </div>
      </div>
    </div>
    }
    <!-- Charts -->
    @if (this.activeTab=='PT') {
    <div id="charts">
      <div class="btn-group" style="
        display: flex;
        flex-direction: row;
        padding: 3px;
        width: 100%;">
        <button class="btn btn-sm btn-primary" style="position: relative;
               z-index: 1;
               display: block;
               padding: 3px;
               width: 105px;
               position: relative;
               z-index: 1;
               display: block;
               padding: 3px;
               margin: 2px;
               border-radius: 3px;" (click)="threeShell()">
          <i class="fa fa-chart-line"></i>
          {{chartVisible?"Stop PT":"Show PT"}}
        </button>
        <button class="btn btn-sm btn-primary" style="position: relative;
               z-index: 1;
               display: block;
               padding: 3px;
               width: 105px;
               position: relative;
               z-index: 1;
               display: block;
               padding: 3px;
               margin: 2px;
               border-radius: 3px;" (click)="appShell()">
          <i class="fa fa-chart-line"></i>
          {{"App PT"}}
        </button>
        <div style="flex-grow: 25;"></div>
        <!-- commented for axis -->
        <button (click)="generatePerformancePDF()" class="btn btn-primary" style="position: relative;
               z-index: 1;
               display: block;
               padding: 3px;
               width: 105px;
               position: relative;
               z-index: 1;
               display: block;
               padding: 3px;
               margin: 2px;
               border-radius: 3px;">
          <i class="fa fa-download"></i> Report
        </button>
      </div>
      @if (isLoading) {
      <div class="loader-overlay">
        <div class="loader"></div>
        @if (counter==1) {
        <div>Initializing Graph...</div>
        }
        @if (counter==2) {
        <div>Building parameters...</div>
        }
        @if (counter!=1 && counter!=2) {
        <div>Fetching device details...</div>
        }
      </div>
      }
      <canvas #systemUsageChart
        [ngStyle]="{'top':isLoading?'-30px':'0px','position':isLoading?'relative':'static'}"></canvas>
      <div class="charts">
        <!-- Metrics Dashboard -->
        <div class="metrics-dashboard">
          <!-- FPS Metrics Card -->
          <div class="metric-card">
            <div class="metric-card-header">
              <div class="metric-title">
                <i class="fa fa-tachometer-alt metric-icon"></i>
                <span>FPS Metrics</span>
              </div>
              <span class="target-badge">Target: 60fps</span>
            </div>
            <div class="metric-grid">
              <div class="metric-item">
                <div class="metric-label">
                  Package
                  <button class="info-btn" data-tooltip="The package name of the application being monitored">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value truncate" [title]="performanceData?.app?.packageName">
                  {{ performanceData?.app?.packageName }}
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Total Frames
                  <button class="info-btn" data-tooltip="Total number of frames rendered during the monitoring session">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ performanceData?.frames?.totalFrames }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Janky Frames
                  <button class="info-btn"
                    data-tooltip="Frames that took longer than 16ms to render, causing visible stuttering">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="status-indicator" [ngClass]="{
              'status-warning': performanceData?.frames?.jankyFrames > 50,
              'status-critical': performanceData?.frames?.jankyFrames > 100,
              'status-good': performanceData?.frames?.jankyFrames <= 50
            }"></span>
                  <span class="metric-value">{{ performanceData?.frames?.jankyFrames }}</span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Missed Vsync
                  <button class="info-btn"
                    data-tooltip="Number of vertical sync signals missed, indicating display refresh issues">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="status-indicator status-good"></span>
                  <span class="metric-value">{{ performanceData?.frames?.missedVsync }}</span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  GPU Pipeline
                  <button class="info-btn"
                    data-tooltip="Graphics processing pipeline used for rendering (e.g., SkiaGL, Vulkan)">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ performanceData?.gpuStats?.pipeline }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Max Resource
                  <button class="info-btn" data-tooltip="Maximum memory allocated for GPU resources">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ performanceData?.memoryPolicy?.maxResourceUsageMB }} MB</div>
              </div>
            </div>
          </div>
          <!-- App & Page Loading Time Card -->
          <div class="metric-card">
            <div class="metric-card-header">
              <div class="metric-title">
                <i class="fa fa-hourglass-half metric-icon"></i>
                <span>App & Page Loading Time</span>
              </div>
              <span class="health-badge" [ngClass]="{
          'health-good': pageLoadingTime?.totalTime <= 1000,
          'health-warning': pageLoadingTime?.totalTime > 1000 && pageLoadingTime?.totalTime <= 3000,
          'health-critical': pageLoadingTime?.totalTime > 3000
        }">
                <i class="fa fa-check-circle"></i>
                {{ pageLoadingTime?.totalTime <= 1000 ? 'Healthy' : pageLoadingTime?.totalTime <=3000 ? 'Moderate'
                  : 'Slow' }} </span>
            </div>
            <div class="metric-grid">
              <div class="metric-item">
                <div class="metric-label">
                  Activity
                  <button class="info-btn" data-tooltip="The Android Activity component that was launched">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ pageLoadingTime?.activity }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Warning
                  <button class="info-btn" data-tooltip="Any warnings detected during app launch">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ pageLoadingTime?.warning || 'None' }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Status
                  <button class="info-btn" data-tooltip="Current status of the activity launch">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ pageLoadingTime?.status }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Launch State
                  <button class="info-btn"
                    data-tooltip="Type of app start: Cold (fresh), Warm (partial cache), or Hot (fully cached)">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">
                  <span class="launch-badge">{{ pageLoadingTime?.launchState }}</span>
                </div>
              </div>
              <div class="metric-item metric-highlight">
                <div class="metric-label">
                  Total Time
                  <button class="info-btn" data-tooltip="Total time from launch intent to first frame displayed">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value-large">{{ pageLoadingTime?.totalTime }} ms</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': pageLoadingTime?.totalTime > 1000,
              'status-critical': pageLoadingTime?.totalTime > 3000,
              'status-good': pageLoadingTime?.totalTime <= 1000
            }"></span>
                </div>
              </div>
              <div class="metric-item metric-highlight">
                <div class="metric-label">
                  Wait Time
                  <button class="info-btn"
                    data-tooltip="Time spent waiting for system resources before app initialization">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-large">{{ pageLoadingTime?.waitTime }} ms</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Complete
                  <button class="info-btn" data-tooltip="Whether the launch completed successfully">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">
                  <span class="complete-badge" [ngClass]="{
              'complete-yes': pageLoadingTime?.complete,
              'complete-no': !pageLoadingTime?.complete
            }">
                    {{ pageLoadingTime?.complete ? 'Yes' : 'No' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- ANR Card -->
          <div class="metric-card anr-card">
            <div class="anr-status-bar" [ngClass]="{
        'anr-green': appANR?.totalEntries === 0,
        'anr-yellow': appANR?.totalEntries > 0 && appANR?.totalEntries <= 3,
        'anr-red': appANR?.totalEntries > 3
      }"></div>
            <div class="metric-card-header">
              <div>
                <div class="metric-title">
                  <i class="fa fa-exclamation-triangle metric-icon"></i>
                  <span>Application Not Responding (ANR)</span>
                </div>
                <div class="metric-subtitle">Monitoring UI thread blocking events > 5000ms</div>
              </div>
              <span class="risk-badge" [ngClass]="{
          'risk-low': appANR?.totalEntries === 0,
          'risk-medium': appANR?.totalEntries > 0 && appANR?.totalEntries <= 3,
          'risk-high': appANR?.totalEntries > 3
        }">
                Risk: {{ appANR?.totalEntries === 0 ? 'LOW' :
                appANR?.totalEntries <= 3 ? 'MEDIUM' : 'HIGH' }} </span>
            </div>
            <div class="metric-grid anr-grid">
              <div class="metric-item">
                <div class="metric-label">
                  Total Entries
                  <button class="info-btn"
                    data-tooltip="Number of ANR events detected where the app became unresponsive">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value-large">{{ appANR?.totalEntries }}</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': appANR?.totalEntries > 1,
              'status-critical': appANR?.totalEntries > 3,
              'status-good': appANR?.totalEntries === 0
            }"></span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Max Entries
                  <button class="info-btn" data-tooltip="Maximum allowed ANR entries before system intervention">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-large">{{ appANR?.maxEntries || '--' }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Low Priority Rate Limit
                  <button class="info-btn" data-tooltip="Rate limiting applied to low-priority ANR reports">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-large">{{ appANR?.lowPriorityRateLimitMs }} ms</div>
              </div>
            </div>
          </div>
          <!-- Battery Usage Card -->
          <div class="metric-card">
            <div class="metric-card-header">
              <div class="metric-title">
                <i class="fa fa-battery-three-quarters metric-icon"></i>
                <span>Battery Usage</span>
              </div>
            </div>
            <div class="metric-grid">
              <div class="metric-item">
                <div class="metric-label">
                  Battery Capacity
                  <button class="info-btn" data-tooltip="Total battery capacity of the device in milliampere-hours">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ batteryUsage?.estimatedBatteryCapacity | number:'1.0-0' }} mAh</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Total Discharge
                  <button class="info-btn" data-tooltip="Total battery power consumed during monitoring session">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ batteryUsage?.dischargeMah | number:'1.0-0' }} mAh</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': batteryUsage?.dischargeMah > 200,
              'status-critical': batteryUsage?.dischargeMah > 500,
              'status-good': batteryUsage?.dischargeMah <= 200
            }"></span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Screen Off Discharge
                  <button class="info-btn" data-tooltip="Battery consumed while screen was off">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ batteryUsage?.screenOffDischargeMah | number:'1.0-0' }} mAh</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Screen On Discharge
                  <button class="info-btn" data-tooltip="Battery consumed while screen was on">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ batteryUsage?.screenOnDischargeMah | number:'1.0-0' }} mAh</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Screen Power
                  <button class="info-btn" data-tooltip="Power consumed specifically by the display">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ batteryUsage?.screenPowerMah | number:'1.2-2' }} mAh</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  CPU Power
                  <button class="info-btn" data-tooltip="Power consumed by the processor">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ batteryUsage?.cpuPowerMah | number:'1.2-2' }} mAh</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Time on Battery
                  <button class="info-btn" data-tooltip="Total time device has been running on battery power">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ formatTime(batteryUsage?.timeOnBatteryMs) }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Screen On Time
                  <button class="info-btn" data-tooltip="Total time the screen has been active">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ formatTime(batteryUsage?.screenOnTimeMs) }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Wake Locks
                  <button class="info-btn"
                    data-tooltip="Number of times the device was prevented from sleeping by the app">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ batteryUsage?.wakeLocks }}</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': batteryUsage?.wakeLocks > 50,
              'status-critical': batteryUsage?.wakeLocks > 100,
              'status-good': batteryUsage?.wakeLocks <= 50
            }"></span>
                </div>
              </div>
            </div>
          </div>
          <!-- Network Statistics Card -->
          <div class="metric-card">
            <div class="metric-card-header">
              <div class="metric-title">
                <i class="fa fa-network-wired metric-icon"></i>
                <span>Network Statistics</span>
              </div>
            </div>
            <div class="metric-grid">
              <div class="metric-item">
                <div class="metric-label">
                  Network Type
                  <button class="info-btn" data-tooltip="Current network connection type (WiFi, 4G, 5G, etc.)">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ networkCondition?.networkType || 'Unknown' }}</span>
                  <span class="network-badge" [ngClass]="{
              'network-online': !networkCondition?.isOffline,
              'network-offline': networkCondition?.isOffline
            }">
                    {{ networkCondition?.isOffline ? 'Offline' : 'Online' }}
                  </span>
                </div>
              </div>
              @if (networkCondition?.isMobileConnected) {
              <div class="metric-item">
                <div class="metric-label">
                  Mobile Network Subtype
                  <button class="info-btn" data-tooltip="Specific mobile network technology (LTE, 5G, etc.)">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ networkCondition?.networkSubtype }}</div>
              </div>
              }
              <div class="metric-item">
                <div class="metric-label">
                  Connection Status
                  <button class="info-btn" data-tooltip="Whether the device is currently connected to a network">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">
                  <span class="complete-badge" [ngClass]="{
              'complete-yes': networkCondition?.isConnected,
              'complete-no': !networkCondition?.isConnected
            }">
                    {{ networkCondition?.isConnected ? 'Connected' : 'Disconnected' }}
                  </span>
                </div>
              </div>
              @if (networkCondition?.signalStrength !== 'Unknown') {
              <div class="metric-item">
                <div class="metric-label">
                  Signal Strength
                  <button class="info-btn" data-tooltip="Quality of the network signal reception">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ networkCondition?.signalStrength }}</span>
                  <span class="status-indicator" [ngClass]="{
              'status-good': networkCondition?.signalStrength === 'Excellent' || networkCondition?.signalStrength === 'Good',
              'status-warning': networkCondition?.signalStrength === 'Fair',
              'status-critical': networkCondition?.signalStrength === 'Poor'
            }"></span>
                </div>
              </div>
              }
              <div class="metric-item">
                <div class="metric-label">
                  Average Latency
                  <button class="info-btn" data-tooltip="Average network round-trip time for data packets">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ pingStats?.avgLatency | number:'1.1-1' }} ms</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': pingStats?.avgLatency > 100,
              'status-critical': pingStats?.avgLatency > 200,
              'status-good': pingStats?.avgLatency <= 100
            }"></span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Min / Max Latency
                  <button class="info-btn" data-tooltip="Lowest and highest network latency values recorded">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">
                  {{ pingStats?.minLatency | number:'1.1-1' }} / {{ pingStats?.maxLatency | number:'1.1-1' }} ms
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  High Latency
                  <button class="info-btn" data-tooltip="Whether high latency (>200ms) was detected">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">
                  <span class="complete-badge" [ngClass]="{
              'complete-no': pingStats?.hasHighLatency,
              'complete-yes': !pingStats?.hasHighLatency
            }">
                    {{ pingStats?.hasHighLatency ? 'Yes' : 'No' }}
                  </span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Packet Loss
                  <button class="info-btn" data-tooltip="Percentage of data packets that failed to reach destination">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ pingStats?.packetLoss | number:'1.1-1' }}%</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': pingStats?.packetLoss > 5,
              'status-critical': pingStats?.packetLoss > 10,
              'status-good': pingStats?.packetLoss <= 5
            }"></span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Packets Sent / Received
                  <button class="info-btn" data-tooltip="Total number of data packets transmitted and received">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ pingStats?.packetsSent }} / {{ pingStats?.packetsReceived }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  WiFi Data Received
                  <button class="info-btn" data-tooltip="Amount of data downloaded over WiFi connection">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ (networkStats?.wifiRxBytes / 1024 / 1024) | number:'1.2-2' }} MB</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  WiFi Data Sent
                  <button class="info-btn" data-tooltip="Amount of data uploaded over WiFi connection">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ (networkStats?.wifiTxBytes / 1024 / 1024) | number:'1.2-2' }} MB</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  WiFi Packets Received
                  <button class="info-btn" data-tooltip="Number of data packets received over WiFi">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ networkStats?.wifiRxPackets | number }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  WiFi Packets Sent
                  <button class="info-btn" data-tooltip="Number of data packets sent over WiFi">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ networkStats?.wifiTxPackets | number }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Mobile Data Received
                  <button class="info-btn" data-tooltip="Amount of data downloaded over mobile network">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ (networkStats?.mobileRxBytes / 1024 / 1024) | number:'1.2-2' }} MB</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Mobile Data Sent
                  <button class="info-btn" data-tooltip="Amount of data uploaded over mobile network">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ (networkStats?.mobileTxBytes / 1024 / 1024) | number:'1.2-2' }} MB</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Mobile Packets Received
                  <button class="info-btn" data-tooltip="Number of data packets received over mobile network">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ networkStats?.mobileRxPackets | number }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Mobile Packets Sent
                  <button class="info-btn" data-tooltip="Number of data packets sent over mobile network">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">{{ networkStats?.mobileTxPackets | number }}</div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Total Data Received
                  <button class="info-btn" data-tooltip="Combined data downloaded from all network sources">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ (networkStats?.totalRxBytes / 1024 / 1024) | number:'1.2-2' }} MB</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': networkStats?.totalRxBytes > 100000000,
              'status-critical': networkStats?.totalRxBytes > 500000000,
              'status-good': networkStats?.totalRxBytes <= 100000000
            }"></span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Total Data Sent
                  <button class="info-btn" data-tooltip="Combined data uploaded to all network sources">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value-wrapper">
                  <span class="metric-value">{{ (networkStats?.totalTxBytes / 1024 / 1024) | number:'1.2-2' }} MB</span>
                  <span class="status-indicator" [ngClass]="{
              'status-warning': networkStats?.totalTxBytes > 50000000,
              'status-critical': networkStats?.totalTxBytes > 200000000,
              'status-good': networkStats?.totalTxBytes <= 50000000
            }"></span>
                </div>
              </div>
              <div class="metric-item">
                <div class="metric-label">
                  Offline Mode
                  <button class="info-btn" data-tooltip="Whether the device is currently offline">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
                <div class="metric-value">
                  <span class="complete-badge" [ngClass]="{
              'complete-no': networkCondition?.isOffline,
              'complete-yes': !networkCondition?.isOffline
            }">
                    {{ networkCondition?.isOffline ? 'Device Offline' : 'Device Online' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- Histograms -->
          <div class="histogram-grid">
            <div class="metric-card">
              <div class="metric-card-header">
                <div class="metric-title">
                  <span>Frame Histogram</span>
                  <button class="info-btn"
                    data-tooltip="Distribution of frame rendering times showing performance consistency">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
              </div>
              <canvas baseChart [data]="histogramChart" [options]="axisOptions('Frame Time (ms)', 'Frame Count')"
                [type]="'bar'" class="histogram-canvas">
              </canvas>
              <div class="histogram-labels">
                <span>0ms</span>
                <span>8ms</span>
                <span>16ms</span>
                <span>32ms+</span>
              </div>
            </div>
            <div class="metric-card">
              <div class="metric-card-header">
                <div class="metric-title">
                  <span>GPU Histogram</span>
                  <button class="info-btn" data-tooltip="Distribution of GPU processing times for rendered frames">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
              </div>
              <canvas baseChart [data]="gpuHistogramChart" [options]="axisOptions('GPU Time (ms)', 'GPU Frame Count')"
                [type]="'bar'" class="histogram-canvas">
              </canvas>
              <div class="histogram-labels">
                <span>0ms</span>
                <span>4ms</span>
                <span>8ms</span>
                <span>16ms+</span>
              </div>
            </div>
          </div>
          <!-- Percentiles -->
          <div class="percentile-grid">
            <div class="metric-card">
              <div class="metric-card-header">
                <div class="metric-title">
                  <i class="fa fa-chart-bar metric-icon"></i>
                  <span>Frame Latency Percentiles</span>
                  <button class="info-btn"
                    data-tooltip="Statistical distribution showing frame rendering times at different percentiles">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
              </div>
              <canvas baseChart [data]="framePercentileChart" [options]="axisOptions('Percentile', 'Latency (ms)')"
                [type]="'bar'" class="histogram-canvas">
              </canvas>
            </div>
            <div class="metric-card">
              <div class="metric-card-header">
                <div class="metric-title">
                  <i class="fa fa-microchip metric-icon"></i>
                  <span>GPU Latency Percentiles</span>
                  <button class="info-btn"
                    data-tooltip="Statistical distribution showing GPU processing times at different percentiles">
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
              </div>
              <canvas baseChart [data]="gpuPercentileChart" [options]="axisOptions('Percentile', 'GPU Latency (ms)')"
                [type]="'bar'" class="histogram-canvas">
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
    <!-- <div class="loader-overlay" *ngIf="isLoading"> -->
    <!-- <div class="loader"></div> -->
    <!-- <div *ngIf="counter==1">Initializing Graph...</div> -->
    <!-- <div *ngIf="counter==2">Building parameters...</div> -->
    <!-- <div *ngIf="counter!=1 && counter!=2">Fetching device details...</div> -->
    <!-- <canvas #systemUsageChart [ngStyle]="{'top':isLoading?'-30px':'0px','position':isLoading?'relative':'static'}"></canvas> -->
    @if (chartVisibleIos) {
    <div>
      <div class="chart-grid">
        <div class="chart-container" id="chartContainer1"></div>
        <div class="chart-container" id="chartContainer2"></div>
        <div class="chart-container" id="chartContainer3"></div>
        <div class="chart-container" id="chartContainer4"></div>
      </div>
    </div>
    }
  </div>
</div>
<ng-template #alertTemplate let-modal>
  <div style="margin: 5px; padding: 5px;" class="modal-body text-center">
    <p class="alert-message" style="font-size:small;overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button style="margin: 5px; padding: 5px;" type="button" class="btn btn-sm btn-success"
        (click)="Ok()">OK</button>&nbsp;
    </div>
  </div>
</ng-template>